import { CelTabItem } from '@savvaslearning/cel-components/dist-stencil/interfaces/components/cel-tab-panel/cel-tab-panel-interfaces';
import { ROUTE_PATHS } from '../common.constants';
import { ModalData } from './common.model';
import { LstAuthModuleOptions } from '@savvaslearning/lst-auth';
import { environment } from '../../../environments/environment';

export const LST_MODULE_OPTIONS: LstAuthModuleOptions = {
    appId: environment.appId,
    authGatewayBaseUrl: environment.authGatewayUrl,
    authContextId: environment.authContextId,
    authGatewayClientId: environment.rbsConfig.clientId,
    rbsTokenScope: environment.rbsConfig.scope,
    ssoBaseUrl: environment.ssoUrl,
    rbsTokenGrantType: environment.rbsConfig.grant_type,
    loginQueryParams: environment.ssoLoginQueryParams,
    errorRoute: environment.errorRoute,
    authCallbackRoute: environment.authCallbackRoute,
};

export const EMPTY_STRING = '';
export const STUDENT_NAME_SEPARATOR = ', ';
export const MIN_UNAVAILABLE_GRADE_FOR_METRICS = 9;

export const TabList: CelTabItem[] = [
    {
        id: 'scaleScore',
        ariaControls: '',
        label: 'tab-list.scale-score',
    },
    {
        id: 'metric',
        ariaControls: '',
        label: 'tab-list.metric-measure',
    },
];

export const NAVIGATION_TABS = [
    {
        identifier: ROUTE_PATHS.CLASS_SUMMARY,
        label: 'class.summary',
        path: ROUTE_PATHS.CLASS_SUMMARY,
    },
    {
        identifier: ROUTE_PATHS.STUDENT_REPORT,
        label: 'student.report',
        path: ROUTE_PATHS.STUDENT_REPORT,
    },
];

export enum IconDetails {
    // COLORS
    COLOR_GRAYDARKER = 'gray-darker',

    // ICON NAMES
    NAME_INFORMATION_CIRCLE = 'information-circle',
    NAME_PRINT = 'print',
    NAME_SORT = 'sort',
    NAME_CARET_UP = 'caret-up',
    NAME_CARET_DOWN = 'caret-down',
    NAME_GO_BACK = 'go-back',
    NAME_ARROW_THICK_UP = 'arrow-thick-up',
    NAME_ARROW_THICK_DOWN = 'arrow-thick-down',
    NAME_CHEVRON_DOWN = 'chevron-down',
    NAME_CHEVRON_LEFT = 'chevron-left',
    NAME_CHEVRON_RIGHT = 'chevron-right',

    // ICON IDS
    END_TO_END_ID = 'cel-help-icon-button',
    STUDENT_PRINT_ID = 'student-print-popup-menu',

    // ALIGNMENTS
    ALIGNMENT_LEFT = 'left',

    // SIZES
    SIZE_XSMALL = 'xsmall',
    SIZE_SMALL = 'small',
    SIZE_REGULAR = 'regular',
    SIZE_LARGE = 'large',

    // VARIANTS
    VARIANT_ICON = 'icon',
}

// Cannot import CelIconSizes from CelComp so added this here for now, used for the CelIconButtonPopoverInterface
export enum CelIconSizes {
    XSMALL = 'xsmall',
    SMALL = 'small',
    REGULAR = 'regular',
    LARGE = 'large',
}

export const DEFAULT_MODAL_DATA: ModalData = {
    dataTransparent: false,
    dataShowCancel: true,
    dataHideClose: false,
    dataHideAccept: false,
    dataDisableAcceptButton: false,
    dataIdentifier: null,
    dataHeader: null,
    dataMessage: null,
    dataCancelLabel: null,
    dataCancelAriaLabel: null,
    dataAcceptLabel: null,
    dataAcceptAriaLabel: null,
    dataCustomClass: null,
    dataReturnFocusId: null,
};

export const REALIZE_FMS_ATTRIBUTES = 'realize.fmsAttributes';
export const FLAG_VALUE_ON = 'ON';
export const FLAG_VALUE_OFF = 'OFF';

export enum FMS_FLAG {
    ENABLE_VIEW_ASSIGN_RESOURCE_PATH_BASED = 'enable-view-assign-resource-path-based',
    ENABLE_DIAGNOSTIC_REPORT_PRINT_ALL_STUDENTS_FUNCTIONALITY = 'enable.diagnostic.report.print.all.students',
}

export const RESOURCE_SEARCH_PARENT_MFE = 'multi-stage-report';
export const RESOURCE_SEARCH_INTEGRATED_AS = 'view-resources';

export const PRINT_SCOPE = {
    THIS_STUDENT: 'this-student',
    ALL_STUDENTS: 'all-students',
} as const;

export type PrintScope = (typeof PRINT_SCOPE)[keyof typeof PRINT_SCOPE];

export const PRINT_THIS_STUDENT_TRANSLATION_KEY = 'student.print.this-student';
export const PRINT_ALL_STUDENTS_TRANSLATION_KEY = 'student.print.all-students';
export const MAX_STUDENTS_FOR_PRINT = 50;

export type TranslationResponse = string | string[] | Record<string, string>;
